import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting, isDirty, getFormValues } from 'redux-form';

import Button from 'components/common/Button';

import objectDiff from 'utils/objectDiff';

import ReferralSourceCreateEditForm from './ReferralSourceCreateEditForm';

const styles = theme => ({
  form: {
    padding: '25px 80px 40px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

const ReferralSourceCreateEditDialog = ({
  form,
  initialValues,
  ID,
  open,
  onClose,
  onSubmitSuccess,
  submitting,
  actions,
  dirty,
  formValues,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {ID ? 'Edit Referral Source' : 'Referral Sourse'}
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <ReferralSourceCreateEditForm
        className={classes.form}
        form={form}
        {...initialValues ? { initialValues } : {}}
        {...ID ? { ID } : {}}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          if (ID) {
            if (Object.keys(objectDiff(formValues, initialValues)).length > 0) {
              actions.submit(form);
            } else {
              onClose();
            }
          } else if (dirty) {
            actions.submit(form);
          } else {
            onClose();
          }
        }}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        {ID ? 'Update Referral' : 'Add Referral'}
      </Button>
    </DialogActions>
  </Dialog>
);

ReferralSourceCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({
    'Name of source': PropTypes.string,
    'Cooperate from': PropTypes.string,
    Email: PropTypes.string,
  }),
  ID: PropTypes.number,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    'Name of source': PropTypes.string,
    'Cooperate from': PropTypes.string,
    Email: PropTypes.string,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

ReferralSourceCreateEditDialog.defaultProps = {
  open: false,
  initialValues: null,
  ID: null,
  onClose: () => {},
  onSubmitSuccess: () => {},
  formValues: null,
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
  dirty: isDirty(ownProps.form)(store),
  formValues: getFormValues(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReferralSourceCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/ReferralSourceCreateEditDialog/ReferralSourceCreateEditDialog.js